// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccessIssueFormController from "./access_issue_form_controller"
application.register("access-issue-form", AccessIssueFormController)

import AccessReportController from "./access_report_controller"
application.register("access-report", AccessReportController)

import AccessReportMapController from "./access_report_map_controller"
application.register("access-report-map", AccessReportMapController)

import ActivityLayoutController from "./activity_layout_controller"
application.register("activity-layout", ActivityLayoutController)

import AddAnotherController from "./add_another_controller"
application.register("add-another", AddAnotherController)

import AddClaimsController from "./add_claims_controller"
application.register("add-claims", AddClaimsController)

import AddClaimsUploadController from "./add_claims_upload_controller"
application.register("add-claims-upload", AddClaimsUploadController)

import AddEligibilityFilesController from "./add_eligibility_files_controller"
application.register("add-eligibility-files", AddEligibilityFilesController)

import AddNoteController from "./add_note_controller"
application.register("add-note", AddNoteController)

import AddProviderCounterController from "./add_provider_counter_controller"
application.register("add-provider-counter", AddProviderCounterController)

import AddUserFormController from "./add_user_form_controller"
application.register("add-user-form", AddUserFormController)

import AddableController from "./addable_controller"
application.register("addable", AddableController)

import AgingWorkstreamRowController from "./aging_workstream_row_controller"
application.register("aging-workstream-row", AgingWorkstreamRowController)

import AjaxTabsController from "./ajax_tabs_controller"
application.register("ajax-tabs", AjaxTabsController)

import AlternateLocationsController from "./alternate_locations_controller"
application.register("alternate-locations", AlternateLocationsController)

import AmountsGenerallyBilledSettingController from "./amounts_generally_billed_setting_controller"
application.register("amounts-generally-billed-setting", AmountsGenerallyBilledSettingController)

import AnalysisEtaController from "./analysis_eta_controller"
application.register("analysis-eta", AnalysisEtaController)

import AnalysisNameUniquenessController from "./analysis_name_uniqueness_controller"
application.register("analysis-name-uniqueness", AnalysisNameUniquenessController)

import ApexChartController from "./apex_chart_controller"
application.register("apex-chart", ApexChartController)

import AppealController from "./appeal_controller"
application.register("appeal", AppealController)

import AppearancePreviewController from "./appearance_preview_controller"
application.register("appearance-preview", AppearancePreviewController)

import AppointmentSchedulerController from "./appointment_scheduler_controller"
application.register("appointment-scheduler", AppointmentSchedulerController)

import AppointmentsController from "./appointments_controller"
application.register("appointments", AppointmentsController)

import ArgyleController from "./argyle_controller"
application.register("argyle", ArgyleController)

import AutoGenerateIdentifiersController from "./auto_generate_identifiers_controller"
application.register("auto-generate-identifiers", AutoGenerateIdentifiersController)

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import AutoSearchController from "./auto_search_controller"
application.register("auto-search", AutoSearchController)

import AutocompleteFieldController from "./autocomplete_field_controller"
application.register("autocomplete-field", AutocompleteFieldController)

import AutofillRevealController from "./autofill_reveal_controller"
application.register("autofill-reveal", AutofillRevealController)

import AutofillSignalController from "./autofill_signal_controller"
application.register("autofill-signal", AutofillSignalController)

import AvailabilityBlockController from "./availability_block_controller"
application.register("availability-block", AvailabilityBlockController)

import BalanceBillDrawerController from "./balance_bill_drawer_controller"
application.register("balance-bill-drawer", BalanceBillDrawerController)

import BillItemBulkActionsController from "./bill_item_bulk_actions_controller"
application.register("bill-item-bulk-actions", BillItemBulkActionsController)

import BillItemFlagController from "./bill_item_flag_controller"
application.register("bill-item-flag", BillItemFlagController)

import BillItemsFilterController from "./bill_items_filter_controller"
application.register("bill-items-filter", BillItemsFilterController)

import BillReviewNoteController from "./bill_review_note_controller"
application.register("bill-review-note", BillReviewNoteController)

import BillTypeController from "./bill_type_controller"
application.register("bill-type", BillTypeController)

import BlueTopNavController from "./blue_top_nav_controller"
application.register("blue-top-nav", BlueTopNavController)

import CadenceHistogramChartController from "./cadence_histogram_chart_controller"
application.register("cadence-histogram-chart", CadenceHistogramChartController)

import CapabilitiesToggleController from "./capabilities_toggle_controller"
application.register("capabilities-toggle", CapabilitiesToggleController)

import CcctDeliveryStatusController from "./ccct_delivery_status_controller"
application.register("ccct-delivery-status", CcctDeliveryStatusController)

import StructuredCallingNotesController from "./structured_calling_notes_controller"
application.register("structured-calling-notes", StructuredCallingNotesController)

import CharityCareApplicationController from "./charity_care_application_controller"
application.register("charity-care-application", CharityCareApplicationController)

import CharityCareApplicationFieldController from "./charity_care_application_field_controller"
application.register("charity-care-application-field", CharityCareApplicationFieldController)

import CharityCareApplicationFormsController from "./charity_care_application_forms_controller"
application.register("charity-care-application-forms", CharityCareApplicationFormsController)

import CharityCareApplicationPdfController from "./charity_care_application_pdf_controller"
application.register("charity-care-application-pdf", CharityCareApplicationPdfController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatVolumeChartController from "./chat_volume_chart_controller"
application.register("chat-volume-chart", ChatVolumeChartController)

import ClaimItemsController from "./claim_items_controller"
application.register("claim-items", ClaimItemsController)

import ClaimReexportFormController from "./claim_reexport_form_controller"
application.register("claim-reexport-form", ClaimReexportFormController)

import ClaimReexportsController from "./claim_reexports_controller"
application.register("claim-reexports", ClaimReexportsController)

import ClaimStatusController from "./claim_status_controller"
application.register("claim-status", ClaimStatusController)

import ClaimsAnalysisController from "./claims_analysis_controller"
application.register("claims-analysis", ClaimsAnalysisController)

import ClaimsColumnsController from "./claims_columns_controller"
application.register("claims-columns", ClaimsColumnsController)

import ClaimsFilterController from "./claims_filter_controller"
application.register("claims-filter", ClaimsFilterController)

import ClaimsViewsController from "./claims_views_controller"
application.register("claims-views", ClaimsViewsController)

import CodeInputController from "./code_input_controller"
application.register("code-input", CodeInputController)

import CoderLayoutController from "./coder_layout_controller"
application.register("coder-layout", CoderLayoutController)

import CoderReviewController from "./coder_review_controller"
application.register("coder-review", CoderReviewController)

import CohortRetentionController from "./cohort_retention_controller"
application.register("cohort-retention", CohortRetentionController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import CompleteReviewController from "./complete_review_controller"
application.register("complete-review", CompleteReviewController)

import ConditionalFieldsController from "./conditional_fields_controller"
application.register("conditional-fields", ConditionalFieldsController)

import ConditionalVisibilityController from "./conditional_visibility_controller"
application.register("conditional-visibility", ConditionalVisibilityController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import ConfigurePiGearController from "./configure_pi_gear_controller"
application.register("configure-pi-gear", ConfigurePiGearController)

import ConfirmModalController from "./confirm_modal_controller"
application.register("confirm-modal", ConfirmModalController)

import ConfirmRemoveUserController from "./confirm_remove_user_controller"
application.register("confirm-remove-user", ConfirmRemoveUserController)

import ConnectStatusController from "./connect_status_controller"
application.register("connect-status", ConnectStatusController)

import ContactSelectorController from "./contact_selector_controller"
application.register("contact-selector", ContactSelectorController)

import CoordinatePickerController from "./coordinate_picker_controller"
application.register("coordinate-picker", CoordinatePickerController)

import CopyableController from "./copyable_controller"
application.register("copyable", CopyableController)

import CoverageWarningPreviewController from "./coverage_warning_preview_controller"
application.register("coverage-warning-preview", CoverageWarningPreviewController)

import CovidTestClaimSubmissionsController from "./covid_test_claim_submissions_controller"
application.register("covid-test-claim-submissions", CovidTestClaimSubmissionsController)

import DailyActivityChartController from "./daily_activity_chart_controller"
application.register("daily-activity-chart", DailyActivityChartController)

import DashboardFiltersController from "./dashboard_filters_controller"
application.register("dashboard-filters", DashboardFiltersController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DebounceSubmitController from "./debounce_submit_controller"
application.register("debounce-submit", DebounceSubmitController)

import DeliveryStarController from "./delivery_star_controller"
application.register("delivery-star", DeliveryStarController)

import DemoMemberFormController from "./demo_member_form_controller"
application.register("demo-member-form", DemoMemberFormController)

import DetailsToggleController from "./details_toggle_controller"
application.register("details-toggle", DetailsToggleController)

import DeferredImageController from "./deferred_image_controller"
application.register("deferred-image", DeferredImageController)

import DevPanelController from "./dev_panel_controller"
application.register("dev-panel", DevPanelController)

import DisableDuringSubmitController from "./disable_during_submit_controller"
application.register("disable-during-submit", DisableDuringSubmitController)

import DisableOnSubmitController from "./disable_on_submit_controller"
application.register("disable-on-submit", DisableOnSubmitController)

import DisclaimerPreviewController from "./disclaimer_preview_controller"
application.register("disclaimer-preview", DisclaimerPreviewController)

import DisclaimerReadMoreController from "./disclaimer_read_more_controller"
application.register("disclaimer-read-more", DisclaimerReadMoreController)

import DocViewerController from "./doc_viewer_controller"
application.register("doc-viewer", DocViewerController)

import DocumentMoveController from "./document_move_controller"
application.register("document-move", DocumentMoveController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropdownCtaController from "./dropdown_cta_controller"
application.register("dropdown-cta", DropdownCtaController)

import DynamicRowsController from "./dynamic_rows_controller"
application.register("dynamic-rows", DynamicRowsController)

import EditClaimPricingController from "./edit_claim_pricing_controller"
application.register("edit-claim-pricing", EditClaimPricingController)

import EditRolesController from "./edit_roles_controller"
application.register("edit-roles", EditRolesController)

import EditableController from "./editable_controller"
application.register("editable", EditableController)

import EmployerPickerController from "./employer_picker_controller"
application.register("employer-picker", EmployerPickerController)

import EvalConversionController from "./eval_conversion_controller"
application.register("eval-conversion", EvalConversionController)

import ExpandToggleController from "./expand_toggle_controller"
application.register("expand-toggle", ExpandToggleController)

import ExpandableClaimsController from "./expandable_claims_controller"
application.register("expandable-claims", ExpandableClaimsController)

import ExpandableInputController from "./expandable_input_controller"
application.register("expandable-input", ExpandableInputController)

import ExpandablePanelController from "./expandable_panel_controller"
application.register("expandable-panel", ExpandablePanelController)

import ExpandableTableRowsController from "./expandable_table_rows_controller"
application.register("expandable-table-rows", ExpandableTableRowsController)

import ExpressScreenerController from "./express_screener_controller"
application.register("express-screener", ExpressScreenerController)

import FeedDeepLinkController from "./feed_deep_link_controller"
application.register("feed-deep-link", FeedDeepLinkController)

import FeedItemLinkController from "./feed_item_link_controller"
application.register("feed-item-link", FeedItemLinkController)

import FeedbackWidgetController from "./feedback_widget_controller"
application.register("feedback-widget", FeedbackWidgetController)

import FhirResourcePickerController from "./fhir_resource_picker_controller"
application.register("fhir-resource-picker", FhirResourcePickerController)

import FhirResourcesController from "./fhir_resources_controller"
application.register("fhir-resources", FhirResourcesController)

import FieldCoordinatesController from "./field_coordinates_controller"
application.register("field-coordinates", FieldCoordinatesController)

import FieldPdfHelpController from "./field_pdf_help_controller"
application.register("field-pdf-help", FieldPdfHelpController)

import FilePickerController from "./file_picker_controller"
application.register("file-picker", FilePickerController)

import FlowbiteDatePickerController from "./flowbite_date_picker_controller"
application.register("flowbite-date-picker", FlowbiteDatePickerController)

import FlowbiteDateRangePickerController from "./flowbite_date_range_picker_controller"
application.register("flowbite-date-range-picker", FlowbiteDateRangePickerController)

import FlyoutController from "./flyout_controller"
application.register("flyout", FlyoutController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import FormatNumberController from "./format_number_controller"
application.register("format-number", FormatNumberController)

import InputFormatController from "./input_format_controller"
application.register("input-format", InputFormatController)

import GenerateStatementController from "./generate_statement_controller"
application.register("generate-statement", GenerateStatementController)

import GooglePlacesFallbackController from "./google_places_fallback_controller"
application.register("google-places-fallback", GooglePlacesFallbackController)

import GuardianInfoController from "./guardian_info_controller"
application.register("guardian-info", GuardianInfoController)

import HandleFormatterController from "./handle_formatter_controller"
application.register("handle-formatter", HandleFormatterController)

import HeaderController from "./header_controller"
application.register("header", HeaderController)

import HideInactiveProvidersController from "./hide_inactive_providers_controller"
application.register("hide-inactive-providers", HideInactiveProvidersController)

import HipaaAuthorizationsController from "./hipaa_authorizations_controller"
application.register("hipaa-authorizations", HipaaAuthorizationsController)

import HospitalEmailController from "./hospital_email_controller"
application.register("hospital-email", HospitalEmailController)

import HospitalRatesImportController from "./hospital_rates_import_controller"
application.register("hospital-rates-import", HospitalRatesImportController)

import HospitalsController from "./hospitals_controller"
application.register("hospitals", HospitalsController)

import HsSelectAllController from "./hs_select_all_controller"
application.register("hs-select-all", HsSelectAllController)

import IdCardScaleController from "./id_card_scale_controller"
application.register("id-card-scale", IdCardScaleController)

import ImplementationDetailController from "./implementation_detail_controller"
application.register("implementation-detail", ImplementationDetailController)

import ImplementationToggleController from "./implementation_toggle_controller"
application.register("implementation-toggle", ImplementationToggleController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InsuranceController from "./insurance_controller"
application.register("insurance", InsuranceController)

import InsuranceDetailsController from "./insurance_details_controller"
application.register("insurance-details", InsuranceDetailsController)

import InvoiceBulkActionsController from "./invoice_bulk_actions_controller"
application.register("invoice-bulk-actions", InvoiceBulkActionsController)

import JackpotNumberController from "./jackpot_number_controller"
application.register("jackpot-number", JackpotNumberController)

import JsonViewController from "./json_view_controller"
application.register("json-view", JsonViewController)

import KeypadController from "./keypad_controller"
application.register("keypad", KeypadController)

import LeftNavController from "./left_nav_controller"
application.register("left-nav", LeftNavController)

import LocalTimestampController from "./local_timestamp_controller"
application.register("local-timestamp", LocalTimestampController)

import LocationOverrideController from "./location_override_controller"
application.register("location-override", LocationOverrideController)

import LogoFallbackController from "./logo_fallback_controller"
application.register("logo-fallback", LogoFallbackController)

import MapboxController from "./mapbox_controller"
application.register("mapbox", MapboxController)

import MarketEditController from "./market_edit_controller"
application.register("market-edit", MarketEditController)

import MarketFormController from "./market_form_controller"
application.register("market-form", MarketFormController)

import MarketStatePickerController from "./market_state_picker_controller"
application.register("market-state-picker", MarketStatePickerController)

import MedicalRecordsController from "./medical_records_controller"
application.register("medical-records", MedicalRecordsController)

import MeetBookingController from "./meet_booking_controller"
application.register("meet-booking", MeetBookingController)

import MermaidController from "./mermaid_controller"
application.register("mermaid", MermaidController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MoetCallOverrideController from "./moet_call_override_controller"
application.register("moet-call-override", MoetCallOverrideController)

import MoetChartController from "./moet_chart_controller"
application.register("moet-chart", MoetChartController)

import MoetTemplateController from "./moet_template_controller"
application.register("moet-template", MoetTemplateController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import MultipleTabOpenerController from "./multiple_tab_opener_controller"
application.register("multiple-tab-opener", MultipleTabOpenerController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NegotiationRowController from "./negotiation_row_controller"
application.register("negotiation-row", NegotiationRowController)

import NextStepSelectController from "./next_step_select_controller"
application.register("next-step-select", NextStepSelectController)

import NpiLookupController from "./npi_lookup_controller"
application.register("npi-lookup", NpiLookupController)

import OfferFormController from "./offer_form_controller"
application.register("offer-form", OfferFormController)

import OffersController from "./offers_controller"
application.register("offers", OffersController)

import PageController from "./page_controller"
application.register("page", PageController)

import PartnerOverridesToggleController from "./partner_overrides_toggle_controller"
application.register("partner-overrides-toggle", PartnerOverridesToggleController)

import PartnersNavigationController from "./partners_navigation_controller"
application.register("partners-navigation", PartnersNavigationController)

import PasskeysController from "./passkeys_controller"
application.register("passkeys", PasskeysController)

import PatientBalanceOverrideController from "./patient_balance_override_controller"
application.register("patient-balance-override", PatientBalanceOverrideController)

import PayerController from "./payer_controller"
application.register("payer", PayerController)

import PaymentMethodsController from "./payment_methods_controller"
application.register("payment-methods", PaymentMethodsController)

import PdfExportController from "./pdf_export_controller"
application.register("pdf-export", PdfExportController)

import PdfPreviewController from "./pdf_preview_controller"
application.register("pdf-preview", PdfPreviewController)

import PickEmployerController from "./pick_employer_controller"
application.register("pick-employer", PickEmployerController)

import PlaidController from "./plaid_controller"
application.register("plaid", PlaidController)

import PlotlyChartController from "./plotly_chart_controller"
application.register("plotly-chart", PlotlyChartController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import PreferredContactsController from "./preferred_contacts_controller"
application.register("preferred-contacts", PreferredContactsController)

import PreferredProviderPreviewController from "./preferred_provider_preview_controller"
application.register("preferred-provider-preview", PreferredProviderPreviewController)

import PreferredProviderRulePickerController from "./preferred_provider_rule_picker_controller"
application.register("preferred-provider-rule-picker", PreferredProviderRulePickerController)

import PreviewFallbackController from "./preview_fallback_controller"
application.register("preview-fallback", PreviewFallbackController)

import PromptCacheHygienePreviewController from "./prompt_cache_hygiene_preview_controller"
application.register("prompt-cache-hygiene-preview", PromptCacheHygienePreviewController)

import ProviderChatController from "./provider_chat_controller"
application.register("provider-chat", ProviderChatController)

import ProviderDetailMapController from "./provider_detail_map_controller"
application.register("provider-detail-map", ProviderDetailMapController)

import ProviderIntelligenceBulkController from "./provider_intelligence_bulk_controller"
application.register("provider-intelligence-bulk", ProviderIntelligenceBulkController)

import ProviderSearchAutocompleteController from "./provider_search_autocomplete_controller"
application.register("provider-search-autocomplete", ProviderSearchAutocompleteController)

import ProviderSearchController from "./provider_search_controller"
application.register("provider-search", ProviderSearchController)

import ProviderSearchMapController from "./provider_search_map_controller"
application.register("provider-search-map", ProviderSearchMapController)

import RangeSelectController from "./range_select_controller"
application.register("range-select", RangeSelectController)

import RegistrationToggleController from "./registration_toggle_controller"
application.register("registration-toggle", RegistrationToggleController)

import RemoveElementController from "./remove_element_controller"
application.register("remove-element", RemoveElementController)

import RepriceController from "./reprice_controller"
application.register("reprice", RepriceController)

import ResearchCharityCareTaskController from "./research_charity_care_task_controller"
application.register("research-charity-care-task", ResearchCharityCareTaskController)

import ResponseSignalsController from "./response_signals_controller"
application.register("response-signals", ResponseSignalsController)

import ReviewActionController from "./review_action_controller"
application.register("review-action", ReviewActionController)

import ReviewBillItemsController from "./review_bill_items_controller"
application.register("review-bill-items", ReviewBillItemsController)

import ReviewGateController from "./review_gate_controller"
application.register("review-gate", ReviewGateController)

import ReviewOtherDocumentController from "./review_other_document_controller"
application.register("review-other-document", ReviewOtherDocumentController)

import SalesTabsController from "./sales_tabs_controller"
application.register("sales-tabs", SalesTabsController)

import SankeyController from "./sankey_controller"
application.register("sankey", SankeyController)

import SavingsController from "./savings_controller"
application.register("savings", SavingsController)

import ScheduledClaimExportController from "./scheduled_claim_export_controller"
application.register("scheduled-claim-export", ScheduledClaimExportController)

import SchemaValidatorController from "./schema_validator_controller"
application.register("schema-validator", SchemaValidatorController)

import ScopeOptionsController from "./scope_options_controller"
application.register("scope-options", ScopeOptionsController)

import ScrollArrowController from "./scroll_arrow_controller"
application.register("scroll-arrow", ScrollArrowController)

import ScrollTabsController from "./scroll_tabs_controller"
application.register("scroll-tabs", ScrollTabsController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SectionDescriptionController from "./section_description_controller"
application.register("section-description", SectionDescriptionController)

import SecureToggleController from "./secure_toggle_controller"
application.register("secure-toggle", SecureToggleController)

import SettlementLetterAcceptanceController from "./settlement_letter_acceptance_controller"
application.register("settlement-letter-acceptance", SettlementLetterAcceptanceController)

import SftpIntegrationsController from "./sftp_integrations_controller"
application.register("sftp-integrations", SftpIntegrationsController)

import SignaturesController from "./signatures_controller"
application.register("signatures", SignaturesController)

import SingleSelectToggleController from "./single_select_toggle_controller"
application.register("single-select-toggle", SingleSelectToggleController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SparklineChartController from "./sparkline_chart_controller"
application.register("sparkline-chart", SparklineChartController)

import SplitViewController from "./split_view_controller"
application.register("split-view", SplitViewController)

import SqlConsoleController from "./sql_console_controller"
application.register("sql-console", SqlConsoleController)

import StripeDisconnectController from "./stripe_disconnect_controller"
application.register("stripe-disconnect", StripeDisconnectController)

import StripeFinancialConnectionsController from "./stripe_financial_connections_controller"
application.register("stripe-financial-connections", StripeFinancialConnectionsController)

import StripeSyncController from "./stripe_sync_controller"
application.register("stripe-sync", StripeSyncController)

import SubtasksController from "./subtasks_controller"
application.register("subtasks", SubtasksController)

import SummaryRefreshController from "./summary_refresh_controller"
application.register("summary-refresh", SummaryRefreshController)

import SyncValueController from "./sync_value_controller"
application.register("sync-value", SyncValueController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TaskBulkAssignController from "./task_bulk_assign_controller"
application.register("task-bulk-assign", TaskBulkAssignController)

import TaskListController from "./task_list_controller"
application.register("task-list", TaskListController)

import TaskPriorityOverridesController from "./task_priority_overrides_controller"
application.register("task-priority-overrides", TaskPriorityOverridesController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ToggleNextRowController from "./toggle_next_row_controller"
application.register("toggle-next-row", ToggleNextRowController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TruncateTooltipController from "./truncate_tooltip_controller"
application.register("truncate-tooltip", TruncateTooltipController)

import TurboGetController from "./turbo_get_controller"
application.register("turbo-get", TurboGetController)

import UploadDocumentController from "./upload_document_controller"
application.register("upload-document", UploadDocumentController)

import UploadFilesFormController from "./upload_files_form_controller"
application.register("upload-files-form", UploadFilesFormController)

import UserExportController from "./user_export_controller"
application.register("user-export", UserExportController)

import UsersSearchController from "./users_search_controller"
application.register("users-search", UsersSearchController)

import VbaIntegrationsController from "./vba_integrations_controller"
application.register("vba-integrations", VbaIntegrationsController)

import WorkflowDiagramController from "./workflow_diagram_controller"
application.register("workflow-diagram", WorkflowDiagramController)

import YetAnotherDatePickerController from "./yet_another_date_picker_controller"
application.register("yet-another-date-picker", YetAnotherDatePickerController)

import YetAnotherStepperController from "./yet_another_stepper_controller"
application.register("yet-another-stepper", YetAnotherStepperController)
